import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const ConversionTaskRBAC = {
  pageID: 'd0abf96852fa17af492ddcfe699374de',
  elementID: {
    TableList: 'fac032eeaf25cbf71105e986006224fe',
    BtnAddTask: 'a2e42d7d3e816bcc78951b76be5ff6f4',
    BtnCancelTask: 'f44829822edbaa85acd71605e0f31133',
  },
} as const

export const useRBACConversionTask = createUseRBAC(ConversionTaskRBAC.elementID)

export type UseRBACConversionTaskType = ReturnType<typeof useRBACConversionTask>
